const Scroll = {
  init() {
    const hintElements = document.querySelectorAll('.js-hint');
    if (hintElements.length === 0) return;
    
    new ScrollHint('.js-hint', {
      // suggestiveShadow: true,
      i18n: {
        scrollable: 'スクロールできます'
      }
    });
    
    // 初期位置を中央に設定
    // this.setCenterScroll();
  },
  
  setCenterScroll() {
    const containers = document.querySelectorAll('.js-hint');
    
    containers.forEach(container => {
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      const centerPosition = (scrollWidth - clientWidth) / 2;
      
      container.scrollLeft = centerPosition;
    });
  }
}

// 初期化
Scroll.init();

export default Scroll;